<template>
    <div class="ml-3">
      <v-card>
        <v-card-text class="pa-0">
          <base-data-grid
            :ref="grid.key"
            :gridKey="grid.key"
            :dataSource="grid.dataSource"
            :columns="grid.columns"
            :actions="grid.actions"
            :exportFileName="title"
            @on-row-action-click="gridRowClick"
            :allowGrouping="false"
            :allowFilterPanel="false"
            :title="title"
          />
        </v-card-text>
      </v-card>
    </div>
  </template>

  <script>
import LoggedUsersAdminService from '@/services/LoggedUsersAdminService';
import Utils from '@/ecm/common/Utils';

export default {
    data() {
        return {
            title: this.$t('LoggedUsers'),
            grid: {
                key: 'loggedUsersAdminGrid',
                dataSource: LoggedUsersAdminService.getGrid(),
                columns: [
                    {
                        field: 'SessionID',
                        caption: this.$t('SessionID'),
                        type: 'string',
                    },
                    {
                        field: 'SourceName',
                        caption: this.$t('Source'),
                        type: 'string',
                    },
                    {
                        field: 'UserDisplayName',
                        caption: this.$t('User'),
                        type: 'string',
                    },
                    {
                        field: 'LoginDate',
                        caption: this.$t('Date'),
                        type: 'datetime',
                        format: this.$store.getters['account/user'].MetricDateFormat
                    },
                    {
                        field: 'Organization',
                        caption: this.$t('Organization'),
                        type: 'string',
                    }

                ],
                actions: [
                    {
                        name: 'delete',
                        icon: 'mdi-delete',
                        tooltip: this.$t('Delete'),
                        color: 'red',
                    },
                ],
            },
        };
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        gridRowClick(action) {
            if (action.name === 'delete') {
                this.delete(action.data);
            }
        },
        delete(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    LoggedUsersAdminService.delete(dto.SessionID).then((result) => {
                        Utils.toast.success(this.$t('User') + ' ' +
                            dto.UserDisplayName + ' ' + this.$t('LoggedOut').toLowerCase());
                        this.gridInstance.refresh();
                    });
                }
            });
        },
    },
};
  </script>
